import { useEffect, useMemo } from 'react'
import { createCustomerDisplayChannel } from 'Views/CustomerDisplay/utils/customerDisplayChannel'

export const useCustomerDisplayChannel = () => {
  const channel = useMemo(() => createCustomerDisplayChannel(), [])

  useEffect(() => {
    return () => {
      channel?.close()
    }
  }, [channel])

  return channel
}
